import React from 'react'
import styles from './LatestBlocks.module.sass'
import { Icon } from '../../../ui/Icon'
import { Block } from '../../../../app/models/generated'
import { NavLink } from 'react-router-dom'
import last_block_icon from '../../../../assets/last_finalized_block_icon.svg'
import {
    calculateReward,
    stringTruncateFromCenter,
    getTimeFromTimestamp,
} from '../../../../utils'

interface wrapperBlock {
    block: Block
}

export const LatestBlock = (props: wrapperBlock) => {
    const currentBlock = props.block

    const reward = calculateReward(currentBlock.rewards) / 10 ** 18

    return (
        <div>
            <div className={styles.latestBlock}>
                <div className={styles.blockHead}>
                    <div className={styles.blockHeadMain}>
                        <img 
                            src={last_block_icon}
                            alt="last_block_icon" 
                        />
                    </div>
                    <div className={styles.blockfont}>
                        <div>
                            <NavLink
                                to={'/block/' + currentBlock.height}>
                                {currentBlock.height}
                            </NavLink>
                        </div>
                        <h2>
                            {/* 6 secs ago(calcuate the time here) */}
                            {/* {getTimeFromTimestamp(currentBlock.timestamp)} */}
                            6 secs ago
                        </h2>
                    </div>
                </div>
                
                {/* the previous code */}
                {/* <div className={styles.underBlockInfo}>
                    <div className={styles.infoRow}>
                        <p className={styles.type}>Txn</p>
                        <p>{currentBlock.tx_count}</p>
                    </div>
                    <div className={styles.infoRow}>
                        <p className={styles.type}>Reward</p>
                        <p>{reward}</p>
                    </div>
                    <div className={styles.infoRow}>
                        <p className={styles.type}>Miner</p>
                        <NavLink
                            to={'/address/' + currentBlock.miner?.hash}
                            className={styles.minerValue}>
                            {stringTruncateFromCenter(
                                currentBlock.miner?.hash,
                                8
                            )}
                        </NavLink>
                    </div>
                </div> */}

                <div className={styles.blockfont}>
                    <div className={styles.blockfont1}>
                        <p>Free Recipient </p>
                        {/* I don't know it is correct but the previous code is that this is miner value showing  */}
                        <NavLink
                            to={'/address/' + currentBlock.miner?.hash}>
                            {stringTruncateFromCenter(
                                currentBlock.miner?.hash,
                                8
                            )}
                        </NavLink>
                    </div>
                    <div>
                        {/* I don't know this is correct it shows the txns */}
                        <p>{currentBlock.tx_count} txns in 12 secs</p> 
                    </div>
                </div>
                <div className={styles.milfont}>
                    {/* currentblock's MIL value */}
                    500 MIL
                </div>
            </div>
        </div>
    )
}
